<template>
  <div class="inventory-location-modal-wrapper">
    <div
      class="inventory-location-modal"
      :class="{ 'inventory-location-modal--sm': inventory.location }"
    >
      <header class="inventory-location-modal__header">
        <p>ИЗБЕРИ ПРОЕКТ</p>
      </header>

      <main :class="{ 'select-location': !inventory.location }">
        <CompaniesTree
          :showActiveProjects="true"
          :justSelecting="true"
          :previewSelected="inventory.location"
          @selected="$set(inventory, 'location', $event), getReporters()"
        />
        <template v-if="inventory.location">
          <div class="users-search">
            <p>ИЗБЕРИ РЪКОВОДИТЕЛ,<br />КОЙТО ДА ПРИЕМЕ ИНСТРУМЕНТА</p>
            <TheInput
              icon="N"
              placeholder="Търсене"
              :dark="true"
              v-model="search"
            />
          </div>
          <ul class="reporters-list">
            <li
              v-for="r in filteredReporters"
              :key="r._id"
              :class="{ selected: inventory.location.reporter === r._id }"
              @click="$set(inventory.location, 'reporter', r._id)"
            >
              {{ r.name }}
            </li>
          </ul>
        </template>
      </main>
      <div class="inventory-location-modal-actions">
        <div class="btns">
          <button class="btn btn-close" @click.prevent="closeModal(false)">
            <span class="mck">F</span>
            Отказ
          </button>
          <button
            class="btn btn-new"
            type="submit"
            value="Submit"
            @click.prevent="submit"
            :disabled="loading"
          >
            <span class="mck">Y</span>
            Запис
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import log from "../mixins/log.js";
import CompaniesTree from "../shared/CompaniesTree.vue";
import TheInput from "../TheInput.vue";
export default {
  components: { CompaniesTree, TheInput },
  mixins: [log],
  props: ["id"],
  computed: {
    ...mapGetters(["getUser"]),
    filteredReporters() {
      return this.reporters.filter((r) =>
        r.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  data() {
    return {
      loading: false,
      reporters: [],
      inventory: {},
      search: "",
    };
  },
  methods: {
    handleStatusCheckboxChange(event, value) {
      if (event.target.checked) this.inventory.status = value;
      else this.inventory.status = "";
    },
    getInventory() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/inventory/${this.id}`)
        .then((response) => {
          this.inventory = response.data;

          this.getReporters();
        });
    },
    getReporters() {
      if (!this.inventory.location) return;
      this.reporters = [];
      // this.$http
      //   .get(`${process.env.VUE_APP_BASE_URI}/auth/users/reporters`)
      //   .then((response) => {
      //     this.reporters = response.data;
      //   });
      this.$http
        .get(
          `${process.env.VUE_APP_BASE_URI}/company/project/${this.inventory.location.project}`
        )
        .then((response) => {
          if (response.data ? response.data[0].reporters : false) {
            this.reporters = response.data[0].reporters;
          }
        });
    },

    checkForm() {
      if (!this.inventory.location) {
        this.$snotify.error("Моля, изберете проект!");
        return;
      }
      if (!this.inventory.location.reporter) {
        this.$snotify.error("Моля, изберете ръководител!");
        return;
      }

      return true;
    },
    submit() {
      if (this.checkForm()) {
        this.loading = true;
        if (!this.inventory.status || this.inventory.status === "onsite") {
          delete this.inventory.part;
          this.inventory.status = "moving";
        }

        const fd = new FormData();
        fd.append("data", JSON.stringify(this.inventory));

        this.$http
          .put(`${process.env.VUE_APP_BASE_URI}/inventory`, fd)
          .then(() => {
            this.$snotify.success("Успешно избрахте локация на инвентар!");
            // this.newLog("editInventory", this.user.username);

            this.closeModal(true);
          })
          .catch((error) => {
            if (typeof error.response.data === "string") {
              this.$snotify.error(error.response.data);
            } else {
              console.log(error.response);
              this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
            }
          })
          .then(() => {
            this.loading = false;
          });
      } else {
        // TODO: Do something
      }
    },
    closeModal(isEdited) {
      // isEdited = true => means something is changed
      // isEdited = false => just close the modal
      this.$emit("close", { isEdited: isEdited });
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        this.submit();
      } else if (e.code === "Escape") {
        this.closeModal(false);
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleEvents);

    this.getInventory();
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped>
.inventory-location-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
}

.inventory-location-modal {
  background-color: #fff;
  border-radius: 4px;
  /* border-top: 10px solid #6d2600; */
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
  /* padding: 10px 20px 0; */
  width: 362px;
  -webkit-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
}
.inventory-location-modal--sm {
  width: 290px;
}

.inventory-location-modal__header {
  font-size: 13px;
  font-weight: 700;
  padding: 1rem;
  text-align: center;
}

.users-search {
  background: #4f4f4f;
  padding: 7px 8px;
}
.users-search p {
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}
.users-search .search-input-wrapper {
  height: 36px;
  margin-top: 5px;
  width: 100%;
}

.inventory-location-modal > main.select-location {
  background: #f0f0f7;
  max-height: 50vh;
  overflow: auto;
  padding: 7px;
}

.reporters-list {
  max-height: 50vh;
  overflow: auto;
}
.reporters-list li {
  cursor: pointer;
  display: block;
  font-weight: 700;
  padding: 9px 18px;
}
.reporters-list li.selected,
.reporters-list li:hover {
  background: #f0f0f7;
}

.inventory-location-modal-actions {
  display: flex;
  justify-content: center;
  padding: 8px 0;
}
.inventory-location-modal-actions .btns {
  gap: 10px;
}
.inventory-location-modal-actions .btn {
  margin: 0;
}

/* Responsive */
@media screen and (max-width: 900px) {
  .inventory-location-modal {
    width: 90%;
  }
}
@media screen and (max-width: 700px) {
  .inventory-location-modal.inventory-location-modal-small {
    width: 90%;
  }
}
@media screen and (max-width: 500px) {
  .inventory-location-modal-actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .btns {
    justify-content: center;
  }
}
@media screen and (max-height: 550px) {
  .inventory-location-modal {
    height: 100%;
  }
}
</style>
